import { render } from "./lock.vue?vue&type=template&id=3e0c721a"
import script from "./lock.vue?vue&type=script&lang=js"
export * from "./lock.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__